module.exports = __webpack_public_path__ + "img/BIT_white05.37e6cad4.jpg";